import React, { useState } from "react";
import "../styles/AdmissionForm.css";
import { submitAdmissionForm } from "../services/gurukulService";

const AdmissionForm = () => {
  const [step, setStep] = useState(1);
  
  const [formData, setFormData] = useState({
    gurukul: "",
    classLevel: "",
    studentName: "",
    fatherName: "",
    village: "",
    tehsil: "",
    district: "",
    state: "",
    contact: "",
    gender: "",
    transactionDetails: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const gurukulClasses = {
    "श्री खेतेश्वर गुरुकुल, मायलावास": ["कक्षा 4", "कक्षा 5", "कक्षा 6", "कक्षा 7", "कक्षा 8", "कक्षा 9"],
    "श्री खेतेश्वर गुरुकुल, बिजरोल खेड़ा": ["कक्षा 2", "कक्षा 3", "कक्षा 4", "कक्षा 5", "कक्षा 6", "कक्षा 7", "कक्षा 8"],
    "श्री खेतेश्वर गुरुकुल, सायला": ["कक्षा अरुण", "कक्षा उदय", "कक्षा प्रभात", "कक्षा प्रथमा", "कक्षा द्वितीया", "कक्षा तृतीया", "कक्षा चतुर्थी", "कक्षा पञ्चमी"],
    "श्री खेतेश्वर गुरुकुल, सवाई छोटी": ["कक्षा अरुण", "कक्षा उदय", "कक्षा प्रभात", "कक्षा प्रथमा", "कक्षा द्वितीया", "कक्षा तृतीया", "कक्षा चतुर्थी", "कक्षा पञ्चमी"],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "gurukul"
        ? {
            classLevel: "",
            gender: value === "श्री खेतेश्वर गुरुकुल, मायलावास" || value === "श्री खेतेश्वर गुरुकुल, बिजरोल खेड़ा"
              ? "Male" // Default to Male for these Gurukuls
              : "", // Reset for others
          }
        : {}),
      }));
    };

  const handleNext = (e) => {
    e.preventDefault();
    if (formData.gurukul && formData.classLevel) {
      setStep(2);
    } else {
      alert("कृपया सभी आवश्यक फ़ील्ड भरें! / Please fill all required fields!");
    }
  };

  const handleBack = () => setStep(1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await submitAdmissionForm(formData);
      alert("आवेदन सफलतापूर्वक जमा हो गया! / Application submitted successfully!");
      
      setFormData({
        gurukul: "",
        classLevel: "",
        studentName: "",
        fatherName: "",
        village: "",
        tehsil: "",
        district: "",
        state: "",
        contact: "",
        gender: "",
        transactionDetails: "",
      });
      setStep(1);
    } catch (error) {
      alert("⚠️ फॉर्म जमा करने में त्रुटि हुई। कृपया सभी आवश्यक फ़ील्ड भरें। / Error in form submission. Please fill all required fields.");
    } finally {
      setIsSubmitting(false);
    }
  };
    

  // return (
  //   <div className="admission-formA">
  //   <div className="admission-form-container">
  //     <h2>प्रवेश फॉर्म / Admission Form</h2>
  //     <p>Application - Fee : 200 Rs</p>
  //     <form className="admission-form">
  //       {step === 1 && (
  //         <>
  //           <div className="form-group">
  //             <label>गुरुकुल का चयन करें / Select Gurukul: <span className="required">*</span></label>
  //             <select name="gurukul" value={formData.gurukul} onChange={handleChange} required>
  //               <option value="">चयन करें / Select</option>
  //               {Object.keys(gurukulClasses).map((gurukul) => (
  //                 <option key={gurukul} value={gurukul}>{gurukul}</option>
  //               ))}
  //             </select>
  //           </div>
  //           <div className="form-group">
  //             <label>कक्षा / Class: <span className="required">*</span></label>
  //             <select name="classLevel" value={formData.classLevel} onChange={handleChange} required disabled={!formData.gurukul}>
  //               <option value="">चयन करें / Select</option>
  //               {formData.gurukul && gurukulClasses[formData.gurukul].map((classLevel) => (
  //                 <option key={classLevel} value={classLevel}>{classLevel}</option>
  //               ))}
  //             </select>
  //           </div>
  //           <button onClick={handleNext} className="next-btn">अगला / Next</button>
  //         </>
  //       )}

  //       {step === 2 && (
  //         <>
  //           <div className="form-group">
  //             <label>नाम / Student Name: <span className="required">*</span></label>
  //             <input type="text" name="studentName" value={formData.studentName} onChange={handleChange} required />
  //           </div>

  //           {!(formData.gurukul === "श्री खेतेश्वर गुरुकुल, मायलावास" || formData.gurukul === "श्री खेतेश्वर गुरुकुल, बिजरोल खेड़ा") && (
  //             <div className="form-group">
  //               <label>लिंग / Gender</label>
  //               <select name="gender" value={formData.gender} onChange={handleChange} required>
  //                 <option value="">चयन करें / Select</option>
  //                 <option value="Boy">बालक / Boy</option>
  //                 <option value="Girl">बालिका / Girl</option>
  //               </select>
  //             </div>
  //           )}

  //           <div className="form-group">
  //             <label>पिता का नाम / Father's Name: <span className="required">*</span></label>
  //             <input type="text" name="fatherName" value={formData.fatherName} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>गाँव / Village: <span className="required">*</span></label>
  //             <input type="text" name="village" value={formData.village} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>तहसील / Tehsil: <span className="required">*</span></label>
  //             <input type="text" name="tehsil" value={formData.tehsil} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>जिला / District: <span className="required">*</span></label>
  //             <input type="text" name="district" value={formData.district} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>राज्य / State: <span className="required">*</span></label>
  //             <input type="text" name="state" value={formData.state} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>संपर्क नंबर / Contact Number: <span className="required">*</span></label>
  //             <input type="tel" name="contact" value={formData.contact} onChange={handleChange} required />
  //           </div>

  //           <div className="form-group">
  //             <label>Transaction Details(Application Fee): <span className="required">*</span></label>
  //             <input type="text" name="transactionDetails" value={formData.transactionDetails} onChange={handleChange} required />
  //           </div>

          

  //           <div className="button-group">
  //             <button type="button" onClick={handleBack} className="back-btn">पीछे जाएं / Back</button>
  //             <button type="submit" onClick={handleSubmit} className="submit-btn" disabled={isSubmitting}>
  //               {isSubmitting ? "जमा किया जा रहा है... / Submitting..." : "जमा करें / Submit"}
  //             </button>
  //           </div>
  //         </>
  //       )}
  //     </form>
  //   </div>
  //   </div>
  // );

  return (
  <div className="admission-formA">
    <div className="admission-form-container" style={{ textAlign: "center" }}>
      <h2>प्रवेश सूचना / Admission Notice 2026-27</h2>

      <p style={{ fontSize: "18px", marginTop: "20px" }}>
        वर्तमान में ऑनलाइन प्रवेश आवेदन
        <strong> Google Form </strong>
        के माध्यम से लिया जा रहा है।
      </p>

      <p style={{ fontSize: "16px", marginTop: "10px" }}>
        कृपया नीचे दिए गए Google Form के माध्यम से आवेदन करें।
      </p>

      {/* Uncomment when Google Form is ready */}
      
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLScno7P8GkPqpCVPehGVaxHauG1fMnqK-VtXmLPNOW68CPdyPQ/viewform?usp=header"
        target="_blank"
        rel="noopener noreferrer"
        className="submit-btn"
        style={{ display: "inline-block", marginTop: "25px" }}
      >
        आवेदन फॉर्म / Open Application
      </a>
     
    </div>
  </div>
);
};

export default AdmissionForm;
